import { OR_Backdrop, OR_Container, OR_Content } from "./OverlayRoot.styled";
import { ReactNode } from "react";

interface OverlayRootProps {
	children: ReactNode;
	onClose: () => void;
}

export const OverlayRoot = ({ children, onClose }: OverlayRootProps) => {
	return (
		<OR_Container
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			transition={{ duration: 0.2 }}
		>
			<OR_Backdrop
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				exit={{ opacity: 0 }}
				transition={{ duration: 0.25 }}
				onClick={onClose}
			/>
			<OR_Content
				initial={{ opacity: 0, scale: 0.96 }}
				animate={{ opacity: 1, scale: 1 }}
				exit={{ opacity: 0, scale: 0.96 }}
				transition={{ duration: 0.25 }}
				onClick={(e) => e.stopPropagation()}
			>
				{children}
			</OR_Content>
		</OR_Container>
	);
};
